import type { QBankStructureLevelItemWithLevel } from '@exam-management/qbs-provider';
import type { OptionSelectionProps } from '@shared/components';

export function getOptionsByPreviousLevelItemId(
  previousLevelItemId: string | null,
  currentLevel: number,
  levelItems: QBankStructureLevelItemWithLevel[],
): OptionSelectionProps[] {
  return levelItems
    .filter((levelItem) => {
      if (!previousLevelItemId) {
        return levelItem.qBankStructureLevel.level === currentLevel;
      }

      return levelItem.parentLevelItemId === previousLevelItemId;
    })
    .sort((a, b) => {
      return a.order - b.order;
    })
    .map((levelItem) => {
      const label = levelItem.order
        ? (levelItem.tag?.name ?? `${levelItem.order}-ไม่ระบุชื่อ`)
        : 'ไม่ระบุ';
      return {
        label,
        value: levelItem.id,
      };
    });
}
